import { render, staticRenderFns } from "./rawMateriaPrize.vue?vue&type=template&id=79aa23e2"
import script from "./rawMateriaPrize.vue?vue&type=script&lang=js"
export * from "./rawMateriaPrize.vue?vue&type=script&lang=js"
import style0 from "./rawMateriaPrize.vue?vue&type=style&index=0&id=79aa23e2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports